import { render, staticRenderFns } from "./Scene5.vue?vue&type=template&id=5f6e78b2&scoped=true&"
import script from "./Scene5.vue?vue&type=script&lang=js&"
export * from "./Scene5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6e78b2",
  null
  
)

export default component.exports